// import React, { useState } from "react";
// import { AiFillFileAdd } from "react-icons/ai";
// import { Link } from "react-router-dom";
// import { RoutePath } from "../../../utility/Constant";
// import { FaRegEdit } from "react-icons/fa";
// import { MdDeleteForever } from "react-icons/md";

// function ManagementsCard({ project, user, handleSingleDelete }) {
//   const { aboutUsManagementsList, aboutUsManagementsListAdd } = RoutePath;
//   const [showMore, setShowMore] = useState(false);
//   const [visibility, setVisibility] = useState(true);

//   const handleDelete = async () => {
//     const res = await handleSingleDelete(project._id);
//     if (typeof res === "boolean" && res === true) {
//       setVisibility(false);
//     }
//   };
//   return (
//     <>
//       {visibility ? (
//         <div className="group relative border flex flex-col overflow-hidden shadow-lg rounded-lg h-full">
//           {project ? (
//             <div className="flex flex-col justify-between h-full">

//                   <figure>
//                     <img
//                       src={project?.image?.url}
//                       alt={project.title + " Image"}
//                       className="h-[120px] md:h-[180px] object-contain w-full"
//                     />
//                   </figure>


//                 {/* Content area should grow */}
//                 <div className="p-4 flex flex-col flex-grow justify-between gap-1">
//                   <div>
//                     <span className="text-xs md:text-base font-medium text-gray-900">
//                       {project.subtitle}
//                     </span>
//                     <h2 className="mb-2 md:text-lg font-semibold">
//                       {project.title}
//                     </h2>
//                     <p className="md:hidden block text-gray-600">
//                       {showMore
//                         ? project.description
//                         : `${project.description?.substring(0, 50)}...`}
//                     </p>
//                     <p className="hidden md:block text-gray-600">
//                       {showMore
//                         ? project.description
//                         : `${project.description?.substring(0, 100)}...`}
//                     </p>
//                   </div>

//                   {/* 👇 Buttons always at bottom */}
//                   <div className=" flex items-center justify-between mt-4 border-t pt-3">
//                     <div className="flex justify-end items-center">
//                       <button
//                         onClick={() => setShowMore((old) => !old)}
//                         className="text-xs md:text-sm text-red-500 hover:text-[#DB0029]"
//                       >
//                         {project.description.length > 99 &&
//                           (showMore ? "Show less" : "Show more")}
//                       </button>
//                     </div>
//                     <div className="flex gap-2 text-xs md:text-base">
//                       <Link
//                         to={`/${aboutUsManagementsList}/${project._id}`}
//                         className="btn btn-outline btn-xs text-blue-500 transition duration-150 hover:text-blue-700 text-center rounded-lg"
//                       >
//                         <FaRegEdit size={20} />
//                       </Link>
//                       {user === "admin" && (
//                         <button
//                           id={project._id}
//                           onClick={handleDelete}
//                           className="btn btn-outline btn-xs text-red-500 px-3 transition duration-150 text-center rounded-lg hover:text-red-700"
//                         >
//                           <MdDeleteForever size={23} />
//                         </button>
//                       )}
//                     </div>
//                   </div>
//                 </div>
//               </div>

//           ) : (
//             <Link
//               to={`/${aboutUsManagementsListAdd}`}
//               className="flex justify-center items-center rounded-xl bg-gray-50 shadow-xl h-full"
//             >
//               <p className="text-8xl group-hover:text-[#DB0029]">
//                 <AiFillFileAdd />
//               </p>
//             </Link>
//           )}
//         </div>
//       ) : null}
//     </>
//   );
// }

// export default ManagementsCard;



import React, { useState } from "react";
import { AiFillFileAdd } from "react-icons/ai";
import { Link } from "react-router-dom";
import { RoutePath } from "../../../utility/Constant";
import { FaRegEdit } from "react-icons/fa";
import { MdDeleteForever } from "react-icons/md";

function ManagementsCard({ project, user, handleSingleDelete, dragHandle }) {
  const { aboutUsManagementsList, aboutUsManagementsListAdd } = RoutePath;
  const [showMore, setShowMore] = useState(false);
  const [visibility, setVisibility] = useState(true);


  const handleDelete = async () => {
    const res = await handleSingleDelete(project._id);
    if (res === true) {
      setVisibility(false);
    }
  };

  return visibility ? (
    <div className="group bg-white relative border flex flex-col overflow-hidden shadow-lg rounded-lg h-full">
      {project ? (
        <div className="flex flex-col justify-between h-full">
          <div className="relative">
            {/* Drag handle */}
            {dragHandle && dragHandle}
            <figure>
              <img
                src={`${process.env.REACT_APP_API_URL}images/${project?.image?.url}`}
                alt={project.title + " Image"}
                className="h-[120px] md:h-[180px] object-contain w-full"
              />
            </figure>
          </div>

          <div className="p-4 flex flex-col flex-grow justify-between gap-1">
            <div>
              <span className="text-xs md:text-base font-medium text-gray-900">
                {project.subtitle}
              </span>
              <h2 className="mb-2 md:text-lg font-semibold">
                {project.title}
              </h2>
              <p className="md:hidden block text-gray-600">
                {showMore
                  ? project.description
                  : `${project.description?.substring(0, 50)}...`}
              </p>
              <p className="hidden md:block text-gray-600">
                {showMore
                  ? project.description
                  : `${project.description?.substring(0, 100)}...`}
              </p>
            </div>

            <div className="flex items-center justify-between mt-4 border-t pt-3">
              <div className="flex justify-end items-center">
                <button
                  onClick={() => setShowMore((old) => !old)}
                  className="text-xs md:text-sm text-red-500 hover:text-[#DB0029]"
                >
                  {project.description.length > 99 &&
                    (showMore ? "Show less" : "Show more")}
                </button>
              </div>
              <div className="flex gap-2 text-xs md:text-base">
                <Link
                  to={`/${aboutUsManagementsList}/${project._id}`}
                  className="btn btn-outline btn-xs text-blue-500 hover:text-blue-700 rounded-lg"
                >
                  <FaRegEdit size={20} />
                </Link>
                {user === "admin" && (
                  <button
                    onClick={handleDelete}
                    className="btn btn-outline btn-xs text-red-500 px-3 hover:text-red-700 rounded-lg"
                  >
                    <MdDeleteForever size={23} />
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>
      ) : (
        <Link
          to={`/${aboutUsManagementsListAdd}`}
          className="flex justify-center items-center rounded-xl bg-gray-50 shadow-xl h-full"
        >
          <p className="text-8xl group-hover:text-[#DB0029]">
            <AiFillFileAdd />
          </p>
        </Link>
      )}
    </div>
  ) : null;
}

export default ManagementsCard;
